module.exports = __webpack_public_path__ + "img/medicare.50e850b6.svg";